import { Nullable } from 'global';
import { VOFilters, VOFilterType } from './main';

export function calcFiltersAmount(filters: Nullable<Partial<VOFilters>>) {
  if (!filters) return 0;

  return Object.entries(filters).reduce<number>((amount, [key, value]) => {
    if (key === VOFilterType.CREATE_DATE_RANGE) return amount;

    if (Array.isArray(value)) return (amount += value.length);

    if (typeof value == 'object') {
      return (amount += Object.values(value).filter(Boolean).length);
    }

    if (typeof value == 'boolean' && value) {
      return (amount += 1);
    }

    return amount;
  }, 0);
}
